import {Component, Input} from '@angular/core';
import {SelectionListOption} from '../selection-list.component';

@Component({
    selector: 'ui-kit-selection-item',
    template: '',
    standalone: false
})
export class SelectionItemComponent implements SelectionListOption<any> {
    @Input() label: string;
    @Input() value: any;
    @Input() disabled = false;
}
